// The web app is now a lightweight Account Portal. The full game experience
// (leaderboards, arena, chat, sales, training, etc.) lives in the native mobile
// apps. The corresponding pages/components REMAIN in the codebase untouched — they
// are simply gated out of the web nav + router here so they can be re-enabled later
// without rebuilding anything. To bring a feature back to web, add its route to
// ENABLED_DASHBOARD_ROUTES and restore its <Route> element in App.js.

export const PORTAL_HOME = "/dashboard/home";

// Routes reachable on web today.
export const ENABLED_DASHBOARD_ROUTES = new Set([
  "/dashboard/home",
  "/dashboard/billing",
]);

// Intentionally disabled on web (mobile-only). Kept here for documentation /
// future re-enablement. GroupMe Integrations was explicitly moved to mobile-only.
export const DISABLED_DASHBOARD_ROUTES = [
  "/dashboard/overview",
  "/dashboard/leaderboard",
  "/dashboard/itinerary",
  "/dashboard/sales",
  "/dashboard/import-sales",
  "/dashboard/chat",
  "/dashboard/teams-arena",
  "/dashboard/training",
  "/dashboard/activity",
  "/dashboard/integrations",
  "/dashboard/employees",
  "/dashboard/settings",
];

// Native app store links. Leave empty until the store listings are live — the
// portal will show an "in review" state instead of a dead link.
export const APP_STORE_URL = "https://apps.apple.com/app/salesarena-hq/id6797144841";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.salesarenahq.app";
